import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { GetInvoiceParams } from './types';

export function useSalesTaxInvoiceById(params: GetInvoiceParams | null) {
  const query = params ? new URLSearchParams() : null;
  if (query && params) {
    query.append('corporationId', params.corporationId.toString());
    query.append('realmId', params.realmId);
  }

  const { data, error, isLoading, mutate } = useSWR<any>(
    params
      ? `new-sales-tax/internal/integration/invoice/${params.invoiceId}?${query}`
      : null,
    params
      ? SWRFetcher(
          {
            method: 'GET',
          },
          undefined
        )
      : null
  );

  return {
    invoice: data,
    error,
    mutate,
    isLoading,
  };
}
